import { BrowserRouter, Route, Routes } from 'react-router'
import { ThemeProvider } from '@emotion/react'
import links from './links'

import publicTheme from '../layouts/public/theme'
import PublicHomePage from '../pages/public/Home'
import LeaveRequestIndoTeamPage from '../pages/public/LeaveRequest/IndoTeam'
import LeaveRequestJapanTeamPage from '../pages/public/LeaveRequest/JapanTeam'
import LeaveRequestMedicalReimbursementPage from '../pages/public/MedicalReimbursement'

import authTheme from '../layouts/auth/theme'
import AuthLoginPage from '../pages/auth/Login'

import adminTheme from '../layouts/admin/theme'
import AdminNotFoundPage from '../pages/admin/NotFound'
import AdminDashboardPage from '../pages/admin/Dashboard'
import AdminLeaveRequestsUnrespondedPage from '../pages/admin/LeaveRequests/Unresponded'
import AdminLeaveRequestsIndoPage from '../pages/admin/LeaveRequests/Indo'
import AdminLeaveRequestsJapanPage from '../pages/admin/LeaveRequests/Japan'
import AdminLeaveRequestDetailPage from '../pages/admin/LeaveRequests/Detail'
import AdminMedicalReimbursementsUnrespondedPage from '../pages/admin/MedicalReimbursements/Unresponded'
import AdminMedicalReimbursementsRespondedPage from '../pages/admin/MedicalReimbursements/Responded'
import AdminMedicalReimbursementDetailPage from '../pages/admin/MedicalReimbursements/Detail'
import AdminMedicalReimbursementEditPage from '../pages/admin/MedicalReimbursements/Edit'
import AdminLeaveRequestEditPage from '../pages/admin/LeaveRequests/Edit'

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={publicTheme}>
        <Routes>
          <Route path={links.public.home()} element={<PublicHomePage />} />
          <Route path={links.public.leaveRequestIndoTeam()} element={<LeaveRequestIndoTeamPage />} />
          <Route path={links.public.leaveRequestJapanTeam()} element={<LeaveRequestJapanTeamPage />} />
          <Route path={links.public.medicalReimbursement()} element={<LeaveRequestMedicalReimbursementPage />} />
        </Routes>
      </ThemeProvider>

      <ThemeProvider theme={authTheme}>
        <Routes>
          <Route path={links.auth.login({})} element={<AuthLoginPage />} />
        </Routes>
      </ThemeProvider>

      <ThemeProvider theme={adminTheme}>
        <Routes>
          <Route path={links.admin.dashboard()} element={<AdminDashboardPage />} />
          <Route path={links.admin.leaveRequestUnresponded()} element={<AdminLeaveRequestsUnrespondedPage />} />
          <Route path={links.admin.leaveRequestIndoTeam()} element={<AdminLeaveRequestsIndoPage />} />
          <Route path={links.admin.leaveRequestJapanTeam()} element={<AdminLeaveRequestsJapanPage />} />
          <Route path={links.admin.leaveRequestDetail({ id: ':id' })} element={<AdminLeaveRequestDetailPage />} />
          <Route path={links.admin.leaveRequestEdit({ id: ':id' })} element={<AdminLeaveRequestEditPage />} />
          <Route
            path={links.admin.medicalReimbursementUnresponded()}
            element={<AdminMedicalReimbursementsUnrespondedPage />}
          />
          <Route
            path={links.admin.medicalReimbursementResponded()}
            element={<AdminMedicalReimbursementsRespondedPage />}
          />
          <Route
            path={links.admin.medicalReimbursementDetail({ id: ':id' })}
            element={<AdminMedicalReimbursementDetailPage />}
          />
          <Route
            path={links.admin.medicalReimbursementEdit({ id: ':id' })}
            element={<AdminMedicalReimbursementEditPage />}
          />

          <Route path='/admin/*' element={<AdminNotFoundPage />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  )
}
